// myMixin.js

export const DEFAULT_EMAILS = [
  {
    language: 'en',
    approveOrderTitle: 'New order request from [[COMPANY]].',
    approvedOrderTitle: 'Order [[EXT_NUMBER]] approved by [[COMPANY]].',
    approveOrderText:
      'Dear [[SUPPLIER]],%0D%0A%0D%0AA new order requires your attention.%0D%0A%0D%0APlease use the following link to review and confirm the order: %0D%0A%0D%0A[[LINK]]%0D%0A%0D%0AThank you and have a great day.',
    approvedOrderText:
      'Dear [[SUPPLIER]],%0D%0A%0D%0AThe order has been approved.%0D%0A%0D%0APlease use the following link to see the order: %0D%0A%0D%0A[[LINK]]%0D%0A%0D%0AThank you and have a great day.',
  },
  {
    language: 'fr',
    approveOrderTitle: 'Nouvelle demande de commande de [[COMPANY]].',
    approvedOrderTitle: 'Commande [[EXT_NUMBER]] approuvé par [[COMPANY]].',
    approveOrderText:
      "Cher [[SUPPLIER]],%0D%0A%0D%0AUne nouvelle commande a besoin de votre attention.%0D%0A%0D%0AVeuillez s'il vous plaît utiliser ce lien pour vérifier et confirmer la commande : %0D%0A%0D%0A[[LINK]]%0D%0A%0D%0AMerci et bonne journée.",
    approvedOrderText:
      'Cher [[SUPPLIER]],%0D%0A%0D%0ALa commande a été approuvée.%0D%0A%0D%0AVeuillez utiliser ce lien pour voir la commande : %0D%0A%0D%0A[[LINK]]%0D%0A%0D%0AMerci et bonne journée.',
  },
];
